import * as yup from "yup";

const REQUIRED_MESSAGE = "O campo ${label} é obrigatório";

/**
 * A janela é por dia (o picker é sem hora): início no começo do dia, fim no fim
 * do dia (inclusivo). Validação e payload usam os mesmos limites, senão começar
 * e terminar no mesmo dia é aceito por um e recusado pelo outro.
 */
export const inicioDoDia = (d: Date) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

export const fimDoDia = (d: Date) => {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
};

/**
 * Schema do comunicado (criar e editar usam o mesmo — os campos não mudam entre
 * os dois fluxos). Mensagens interpolam `${label}` para nomear o campo no erro
 * inline e no tooltip do "Próximo" (doc §5.1).
 */
export const comunicadoSistemaSchema = yup.object({
  titulo: yup.string().label("Título").trim().required(REQUIRED_MESSAGE).max(200),
  resumo: yup.string().label("Resumo").trim().required(REQUIRED_MESSAGE).max(300),
  conteudo: yup.string().label("Conteúdo").optional().default(""),
  nivel: yup
    .string()
    .label("Nível")
    .oneOf(["INFORMATIVO", "ALERTA", "CRITICO"], "Selecione um nível")
    .required(REQUIRED_MESSAGE),
  inicioEm: yup
    .date()
    .label("Início")
    .typeError("Informe uma data de início válida")
    .required(REQUIRED_MESSAGE),
  fimEm: yup
    .date()
    .label("Fim")
    .nullable()
    .optional()
    .typeError("Informe uma data de fim válida")
    // Compara os limites do dia, como o payload: mesmo dia é válido (00:00 → 23:59).
    .test(
      "depois-do-inicio",
      "O fim não pode ser antes do início",
      (fimEm, ctx) =>
        !fimEm || !ctx.parent.inicioEm || fimDoDia(fimEm) > inicioDoDia(ctx.parent.inicioEm),
    )
    // Crítico exige prazo: o aceite obrigatório não pode ser cobrado para sempre.
    .when("nivel", {
      is: "CRITICO",
      then: (schema) =>
        schema.required("O comunicado crítico exige uma data de fim — o aceite tem prazo"),
    }),
  // Segmentação (§2.2): vazios os dois = comunicado global.
  cargos: yup.array().of(yup.string().required()).default([]),
  areas: yup.array().of(yup.string().required()).default([]),
});

export type ComunicadoSistemaFormData = yup.InferType<typeof comunicadoSistemaSchema>;
